import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var DashboardFilled = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M7.50008 1.66666H3.33341C2.41425 1.66666 1.66675 2.41416 1.66675 3.33332V9.16666C1.66675 10.0858 2.41425 10.8333 3.33341 10.8333H7.50008C8.41925 10.8333 9.16675 10.0858 9.16675 9.16666V3.33332C9.16675 2.41416 8.41925 1.66666 7.50008 1.66666ZM16.6667 1.66666H12.5001C11.5809 1.66666 10.8334 2.41416 10.8334 3.33332V5.83332C10.8334 6.75249 11.5809 7.49999 12.5001 7.49999H16.6667C17.5859 7.49999 18.3334 6.75249 18.3334 5.83332V3.33332C18.3334 2.41416 17.5859 1.66666 16.6667 1.66666ZM7.50008 12.5H3.33341C2.41425 12.5 1.66675 13.2475 1.66675 14.1667V16.6667C1.66675 17.5858 2.41425 18.3333 3.33341 18.3333H7.50008C8.41925 18.3333 9.16675 17.5858 9.16675 16.6667V14.1667C9.16675 13.2475 8.41925 12.5 7.50008 12.5ZM16.6667 9.16666H12.5001C11.5809 9.16666 10.8334 9.91416 10.8334 10.8333V16.6667C10.8334 17.5858 11.5809 18.3333 12.5001 18.3333H16.6667C17.5859 18.3333 18.3334 17.5858 18.3334 16.6667V10.8333C18.3334 9.91416 17.5859 9.16666 16.6667 9.16666Z",
    fill: fill
  }));
};
export { DashboardFilled as default };
//# sourceMappingURL=DashboardFilled.js.map
